<template>
    <div style="font-size: 12px;">
        <v-row style="font-size: 12px;">
            <v-col cols="11" sm="6">
                সার্কুলার নং ০৬/২০১০ এর ০৪(ক) অনুচ্ছেদ দ্রষ্টব্য
            </v-col>
            <v-col cols="11" sm="5" style="text-align: right; text-decoration: underline;">
                ফরম 'ঘ'
            </v-col>
        </v-row>
        <div style="margin-top: 5px; text-align: center;">
            <div style="font-size: 14px;">রপ্তানি উন্নয়ন ব্যুরো/সংশ্লিষ্ট</div>
            <div style="font-size: 14px; text-decoration: underline;">এসোসিয়েশন কর্তৃক প্রদেয় সনদপত্র</div>
            <div style="margin-top: 5px; text-decoration: underline;">জাহাজ রপ্তানি খাতে ভর্তুকি প্রাপ্তির প্রত্যয়ন সনদপত্র ।</div>
        </div>
        <v-row style="margin-top: 3px;">
            <v-col cols="11" sm="4">
                ১। আবেদনকারী প্রতিষ্ঠানের নামঃ
                <div style="margin-left: 15px;">ঠিকানাঃ</div>
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.SvForm.User.OrganizationName }}
                <div>{{ formData.SvForm.OfficeAddress }}, {{$globalHelpers.getThanaName(formData.SvForm.OfficeThanaId)}}, {{$globalHelpers.getDistrictName(formData.SvForm.OfficeDistrictId)}}</div>
            </v-col>
        </v-row>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ২। রপ্তানি ঋণপত্রের নম্বরঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.SvForm.LcNo }}
                <span style="margin-left: 5px;"></span>তারিখঃ {{ $globalHelpers.getFormattedDate(formData.SvForm.LcDate, '', 'DD/MM/YYYY') }}
                <span style="margin-left: 5px;"></span>মূল্যমানঃ {{ $globalHelpers.getCurrencyName(formData.SvForm.LcCurrencyId) }} {{ formData.SvForm.LcValue }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ৩। বিদেশি ক্রেতার নামঃ
                <div style="margin-left: 15px;">ঠিকানাঃ</div>
            </v-col>
            <v-col cols="11" sm="7" v-if="formData.SvForm.Importer">
                {{formData.SvForm.Importer.Name}}
                <div>{{formData.SvForm.DestinationAddress}}, {{formData.SvForm.DestinationCity}}, {{formData.SvForm.DestinationZipCode}}, {{ $globalHelpers.getCountryNameById(formData.SvForm.DestinationCountryId)}}</div>
            </v-col>
        </v-row>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ৪। বিদেশি ক্রেতার ব্যাংকের নামঃ
                <div style="margin-left: 15px;">ঠিকানাঃ</div>
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.ImporterBankName }}
                <div>{{ formData.ImporterBankAddress }}</div>
            </v-col>
        </v-row>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ৫। ক) ইনভয়েস নম্বরঃ
                <div style="margin-left: 15px;">খ) ইনভয়েসে উল্লেখিত পণ্যের পরিমাণঃ</div>
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.SvForm.InvoiceNo }} <span style="margin-left: 5px;"></span>তারিখঃ {{ $globalHelpers.getFormattedDate(formData.SvForm.InvoiceDate, '', 'DD/MM/YYYY') }}
                <div>
                    <span v-for="(quantity, i) in materialTotals.hscode.quantities" :key="i"><span v-if="i !== 0">,</span> {{quantity.total}} {{ $globalHelpers.getUnitTypName(quantity.unitTypeId) }}</span>
                    <span style="margin-left: 5px;"></span>মূল্যঃ {{ $globalHelpers.getCurrencyName(formData.SvForm.InvoiceCurrencyId) }} {{ formData.SvForm.InvoiceValue }}</div>
            </v-col>
        </v-row>
        <div style="margin-top: 5px;">
            ৬। ক) রপ্তানি পণ্যে ব্যবহৃত স্থানীয় উপকরণাদির বর্ণনাঃ
            <v-simple-table dense style="margin-left: 32px;">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th style="text-align: left;">উপকরণের নাম ও পরিমাণ</th>
                        <th style="text-align: right;">মূল্য</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(material, i) in formData.IncentiveFormLocalMaterials" :key="i">
                        <td>{{ material.MAterial }}, {{ material.Qty }} {{ $globalHelpers.getUnitTypName(material.UnitTypeId) }}</td>
                        <td style="text-align: right;">{{ $globalHelpers.getCurrencyName(material.CurrencyId) }} {{ material.Price }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <div class="mt-2 ml-4">খ) সংগ্রহসূত্র (সরবরাহকারীর নাম ও ঠিকানা):</div>
            <v-simple-table dense style="margin-left: 32px;">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th style="text-align: left;">সরবরাহকারীর নাম</th>
                        <th style="text-align: left;">ঠিকানা</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(material, i) in formData.IncentiveFormLocalMaterials" :key="i">
                        <td>{{ material.SupplierName }}</td>
                        <td>{{ material.SupplierAddress }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
        <div style="margin-top: 5px;">
            <div v-if="formData.IncentiveTypeId !== 3">
                ৭। ক) রপ্তানি পণ্যের বিবরণঃ
                <v-simple-table dense style="margin-left: 32px;">
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th style="text-align: left;">পণ্যের বিবরণ</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(hsCode, i) in formData.SvForm.SvFormHSCodes" :key="i">
                            <td>{{ hsCode.HSCode.Code }}: {{ hsCode.HSCode.Description}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>

            <v-row style="margin-top: 1px;">
                <v-col cols="11" sm="4">
                    <div style="margin-left: 15px;">
                        খ) প্রকৃত রপ্তানিকৃত পণ্যের পরিমাণঃ
                    </div>
                </v-col>
                <v-col cols="11" sm="7">
                    <span v-for="(quantity, i) in materialTotals.hscode.quantities" :key="i"><span v-if="i !== 0">,</span> {{quantity.total}} {{ $globalHelpers.getUnitTypName(quantity.unitTypeId) }}</span> &nbsp;
                    মূল্যঃ <span v-for="(price, i) in materialTotals.hscode.prices" :key="i">{{ $globalHelpers.getCurrencyName(price.currencyId) }} <span v-if="i !== 0">,</span> {{price.total}}</span>
                </v-col>
            </v-row>
        </div>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ৮। জাহাজীকরণের তারিখঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ $globalHelpers.getFormattedDate(formData.SvForm.BLDate, '', 'DD/MM/YYYY') }} <span style="margin-left: 5px;"></span>গন্তব্য বন্দরঃ {{ formData.SvForm.DestinationPort }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ৯। ইএক্সপি নম্বরঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ $globalHelpers.getFormattedEXPNo(formData.SvForm.EXPNo)  }} <span style="margin-left: 5px;"></span>তারিখঃ {{ $globalHelpers.getFormattedDate(formData.SvForm.EXPDate, '', 'DD/MM/YYYY') }} <span style="margin-left: 5px;"></span>মূল্যঃ {{ $globalHelpers.getCurrencyName(formData.SvForm.ExpCurrencyId) }} {{ formData.SvForm.ExpValue }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ১০। মোট প্রত্যাবাসিত রপ্তানি মূল্য (বৈদেশিক মূদ্রায়):
            </v-col>
            <v-col cols="11" sm="7">
                {{ $globalHelpers.getCurrencyName(formData.RepatriatedValueCurrencyId) }} {{ formData.RepatriatedValue }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ১১। প্রত্যাবাসিত রপ্তানি মূল্যের সনদপত্র নম্বরঃ
            </v-col>
            <v-col cols="11" sm="7">
                {{ formData.PRCId }} <span style="margin-left: 5px;"></span>তারিখঃ {{ $globalHelpers.getFormattedDate(formData.PRCDate, '', 'DD/MM/YYYY') }}
            </v-col>
        </v-row>
        <v-row style="margin-top: 0;">
            <v-col cols="11" sm="4">
                ১২। নীট এফওবি মূল্যঃ
            </v-col>
            <v-col cols="11" sm="7">
                ভর্তুকির জন্য {{ $globalHelpers.getCurrencyName(formData.RealisedNetFOBValueCurrencyId) }} {{ formData.RealisedNetFOBValue }} (মোট এফওবি মূল্যঃ <span v-for="(price, i) in materialTotals.hscode.prices" :key="i">{{ $globalHelpers.getCurrencyName(price.currencyId) }} <span v-if="i !== 0">,</span> {{price.total}}</span>)
            </v-col>
        </v-row>
        <div class="incentive-footer-declaration">
            <div style="margin-top: 20px; text-align: right;">(রপ্তানিকারকের স্বাক্ষর ও তারিখ)</div>
            <div style="margin-top: 10px;">
                এতদ্বারা প্রত্যয়ন করা যাইতেছে যে, আমাদের নিজস্ব কারখানায় উৎপাদিত জাহাজ রপ্তানির বিপরীতে রপ্তানি ভর্তুকীর জন্য উপরোক্ত অনুচ্ছেদসমূহের বক্তব্য সঠিক ও নির্ভুল। বিদেশী ক্রেতা/আমদানিকারকের ক্রয়াদেশের যথার্থতা/বিশ্বাসযোগ্যতা সম্পর্কেও নিশ্চিত করা হইলো।
            </div>
            <div style="margin-top: 50px; text-align: right;">(রপ্তানিকারকের স্বাক্ষর ও তারিখ)</div>
            <div style="margin-top: 10px;">
                রপ্তানিকারকের উপরোক্ত ঘোষণাগুলির যথার্থতা যাচাইয়ে সঠিক পাওয়া গিয়াছে; ঘোষিত রপ্তানিমূল্য যুক্তিযুক্ত ও বিদ্যমান আন্তর্জাতিক বাজার মূল্যের সংগে সংগতিপূর্ণ পাওয়া গিয়াছে। প্রত্যাবাসিত রপ্তানি মূলোর অনুকূলে উপরোক্ত রপ্তানিকারককে রপ্তানি ভর্তুকি প্রদানের জন্য সুপারিশ করা হইল।
            </div>
            <div style="margin-top: 40px; text-align: right;">রপ্তানি উন্নয়ন ব্যুরো/সংশ্লিষ্ট এসোসিয়েশন এর দুইজন কর্মকর্তার স্বাক্ষর, তারিখ ও সীল</div>
        </div>

        <div class="incentive-footer-warning-boxed-centered" style="margin-top: 5px;">
            কোন প্রকার ঘষামাজা, কাটা ছেঁড়া বা সংশোধন করা হলে এই প্রত্যয়নপত্র বাতিল বলিয়া গণ্য হইবে।
        </div>
    </div>
</template>

<script>
export default {
    name: "IncentiveForm10",
    data: function() {
        return {}
    },
    props: {
        formData: {
            type: Object,
            default: ()=> null
        },
        materialTotals: {
            type: Object,
            default: ()=> null
        },
    },
    methods: {

    },
}
</script>

<style scoped>
    table tr td, table tr th{
        padding: 0 !important;
        margin: 0 !important;
        height: 5px !important;
        font-size: 12px !important;
    }
    .incentive-pdf-root{
        font-size: 12px;
    }
</style>